import { useEffect } from 'react'

// Injects hidden players_attributes inputs into the Rails member form so past-round
// index edits post with the form. Also an external-DOM sync (REACT-089).
// Past Rounds Summary manages the 18-hole index only, so only usga_index is posted
// (nine_hole_index is left untouched by this section).
const useSyncPlayersToRailsForm = (rounds) => {
  useEffect(() => {
    if (!rounds || rounds.length === 0) return
    const anchor = document.getElementById('member_hs_usga_index')
    const form = anchor && anchor.closest('form')
    if (!form) return

    rounds.forEach((round, index) => {
      const ensure = (name, id, value) => {
        if (document.getElementById(id)) return
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = name
        input.id = id
        input.value = value || ''
        form.appendChild(input)
      }
      ensure(`member[players_attributes][${index}][id]`, `player_${round.player_id}_id`, round.player_id)
      ensure(`member[players_attributes][${index}][usga_index]`, `player_${round.player_id}_usga_index`, round.usga_index)
    })
  }, [rounds])
}

export default useSyncPlayersToRailsForm
